var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, computed, makeObservable, observable } from "mobx";
import { logger } from "../logger/store-logger";
import { TasksType } from "./tasks-store-interface";
export class TasksStore {
    constructor() {
        this.privateSelectedTask = undefined;
        //observable.map was chosen to allow for a simpler integration with AGGrid, do not use unless you have a similar requirement
        this.openTasks = observable.map();
        this.queuedTasks = observable.map();
        this.scheduledTasks = observable.map();
        this.closedTasks = observable.map();
        makeObservable(this);
    }
    get selectedTask() {
        return this.privateSelectedTask;
    }
    getTasksByType(tasksType) {
        switch (tasksType) {
            case TasksType.Open:
                return this.openTasks;
            case TasksType.Queued:
                return this.queuedTasks;
            case TasksType.Scheduled:
                return this.scheduledTasks;
            case TasksType.Closed:
                return this.closedTasks;
            default:
                throw new Error("Invalid tasks type");
        }
    }
    pollForQueuedTasks(sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            logger.info("[TasksStore] NOT IMPLEMENTED - pollForQueuedTasks, sortBy:", sortBy);
        });
    }
    fetchNextPageOfTasks(tasksType) {
        return __awaiter(this, void 0, void 0, function* () {
            logger.info("[TasksStore] NOT IMPLEMENTED - fetchNextPageOfTasks, tasksType:", tasksType);
            return false;
        });
    }
    setSelectedTask(taskId) {
        var _a, _b, _c;
        if (taskId !== "") {
            const task = (_c = (_b = (_a = this.openTasks.get(taskId)) !== null && _a !== void 0 ? _a : this.queuedTasks.get(taskId)) !== null && _b !== void 0 ? _b : this.scheduledTasks.get(taskId)) !== null && _c !== void 0 ? _c : this.closedTasks.get(taskId);
            if (task) {
                this.privateSelectedTask = task;
            }
        }
        else {
            this.privateSelectedTask = undefined;
        }
    }
}
__decorate([
    observable
], TasksStore.prototype, "privateSelectedTask", void 0);
__decorate([
    computed
], TasksStore.prototype, "selectedTask", null);
__decorate([
    observable.ref
], TasksStore.prototype, "openTasks", void 0);
__decorate([
    observable.ref
], TasksStore.prototype, "queuedTasks", void 0);
__decorate([
    observable.ref
], TasksStore.prototype, "scheduledTasks", void 0);
__decorate([
    observable.ref
], TasksStore.prototype, "closedTasks", void 0);
__decorate([
    action
], TasksStore.prototype, "pollForQueuedTasks", null);
__decorate([
    action
], TasksStore.prototype, "fetchNextPageOfTasks", null);
__decorate([
    action
], TasksStore.prototype, "setSelectedTask", null);
